<template>
  <b-modal v-bind:id="modId" v-bind:title="titleMsg" hide-footer>
    <b-form>
      <b-form-group>
        <b-form-textarea
          v-model="msg"
          rows="3"
          max-rows="6"
          maxlength="500"
        ></b-form-textarea>
      </b-form-group>
    </b-form>
    <b-button variant="primary" block @click='clickYes'>{{ yesButtonMsg }}</b-button>
    <b-button block @click='clickNo'>{{ noButtonMsg }}</b-button>
  </b-modal>
 </template>

<script>
export default {
  name: 'Modal',
  props: ['modId', 'titleMsg', 'msg', 'yesButtonMsg', 'noButtonMsg'],
  methods: {
    clickYes: function () {
      this.$parent.comments = this.msg
      this.$parent.modalResult = true
      this.confirmModal()
    },
    clickNo: function () {
      this.$parent.comments = ''
      this.$parent.modalResult = false
      this.confirmModal()
    },
    confirmModal () {
      this.$emit('confirm')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CalteCommentsModal.vue